<template>
	<div class="inter">
		<img class="interani" :src="mode[0]">
	</div>
</template>

<script>
	export default {
        name: 'zhuanzuoxiayoushang',
        props: ['mode'],
        data () {
            return {}
        }
    }
</script>

<style scoped lang="less">
	.inter {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		z-index: 8;
		pointer-events: none;
	}
    .interani{
        width: @bw * 2.528;
        top: @bw * 0.558;
        left: @bw * 0.347;
        animation: interani 4s linear both;
    }
    @keyframes interani {
        0%{
            opacity: 0;
            transform: translate(-@bw * 1.111, @bw * 1.736) rotateZ(0);
        }
        10% {
            opacity: 1;
        }
        50% {
            opacity: 1;
            transform: translate(-@bw * 0.722, -@bw * 0.311) rotateZ(270deg);
        }
        90% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translate(@bw * 0.028, -@bw * 2.439) rotateZ(540deg);
        }
    }
</style>